function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M15,2l4,4l-4,4V7h-4V5h4V2z M8,5C7.4,5,7,5.4,7,6s0.4,1,1,1s1-0.4,1-1S8.6,5,8,5z M4,5C3.5,5,3,5.4,3,6 s0.5,1,1,1s1-0.4,1-1S4.6,5,4,5z M5,15h4v-2H5v-3l-4,4l4,4V15z M12,15c0.6,0,1-0.4,1-1s-0.4-1-1-1s-1,0.4-1,1S11.4,15,12,15z M16,15 c0.5,0,1-0.4,1-1s-0.5-1-1-1c-0.6,0-1,0.4-1,1S15.4,15,16,15z"
});

var SvgOfficeToPickup = function SvgOfficeToPickup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOfficeToPickup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/office_to_pickup.404b0d61.svg";
export { ForwardRef as ReactComponent };